"use client"

import { useEffect, useState } from "react"
import { Skeleton } from "@/components/ui/skeleton"

interface NewsletterStats {
  name: string
  active: number
}

export default function Newsletters() {
  const [stats, setStats] = useState<NewsletterStats[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const newsletters = [
    "thechamps",
    "thenews",
    "thebizness",
    "rising",
    "goget",
    "healthtimes",
    "thestories",
    "thejobs",
    "dollarbill",
    "trendreport"
  ]

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        
        if (!user.token) {
          throw new Error('Token de autenticação não encontrado')
        }

        const promises = newsletters.map(async (newsletter) => {
          try {
            const response = await fetch(
              `https://waffle-v2.thenewcc.workers.dev/newsletters/subscribers/${newsletter}`,
              {
                headers: {
                  'Authorization': `Bearer ${user.token}`
                }
              }
            )
            
            if (!response.ok) {
              throw new Error(`Erro ao buscar dados para ${newsletter}`)
            }
            
            const data = await response.json()
            return { name: newsletter, active: data.active || 0 }
          } catch (err) {
            console.error(`Erro ao buscar ${newsletter}:`, err)
            return { name: newsletter, active: 0 }
          }
        })

        const results = await Promise.all(promises)
        setStats(results)
      } catch (error) {
        console.error("Erro ao buscar estatísticas:", error)
        setError('Erro ao carregar dados das newsletters')
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [])

  if (error) {
    return (
      <div className="text-xs text-red-600 mt-2">
        {error}
      </div>
    )
  }

  if (loading) {
    return (
      <div className="space-y-2 mt-2">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <Skeleton className="h-6 w-full rounded" />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="mt-2">
      <div className="max-h-[300px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600 scrollbar-track-transparent">
        {stats
          .sort((a, b) => b.active - a.active)
          .map((newsletter) => (
            <div
              key={newsletter.name}
              className="flex items-center justify-between py-1.5 px-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <img
                src={`https://dash.testeswaffle.org/${newsletter.name}.webp`}
                alt={newsletter.name}
                className="h-4 w-auto"
              />
              <span className="text-xs font-medium text-gray-900 dark:text-gray-100">
                {newsletter.active.toLocaleString()}
              </span>
            </div>
          ))}
      </div>
    </div>
  )
}